module.exports = __webpack_public_path__ + "assets/img/5e8b02ac1003d6a1531e4c9d2168b734.svg";